import React, { useState } from 'react'
import Plus from '../icons/Plus'
import Modal from './Modal'
import UnitModal from './UnitModal'
import { useDispatch } from 'react-redux'
import { CREATE_UNIT } from '../redux/unitsReducer'
type Props = {}

const AddUnitButton = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()

  const handleSubmit = ({ name, description, image }: { name: string; description: string; image: string }) => {
    if (!name || !description || !image) return
    dispatch(CREATE_UNIT({ name, description, image }))
    setIsOpen(false)
  }

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="bg-slateGray px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer mt-2">
        <div className="text-white w-5 h-5">
          <Plus />
        </div>
        <div className="text-14 font-semibold text-white">Add Unit</div>
      </button>
      <Modal isOpen={isOpen} toggleModal={() => setIsOpen(!isOpen)}>
        <UnitModal onSubmit={handleSubmit} />
      </Modal>
    </>
  )
}

export default AddUnitButton
